import * as React from "react";

export const TermsAndPrivacy = ({ subdued = false }: { subdued?: boolean }) => (
  <div
    className={
      subdued
        ? "w-full text-sm leading-5 text-muted"
        : "unselectable text-sm text-placeholder"
    }
  >
    By signing up, you agree to the Replo
    <a
      className={
        subdued
          ? "px-1 text-muted underline underline-offset-2 hover:text-default"
          : "text-primary px-1 no-underline"
      }
      href="https://replo.app/terms"
      target="_blank"
      rel="noreferrer"
    >
      Terms and Conditions
    </a>
    and
    <a
      className={
        subdued
          ? "px-1 text-muted underline underline-offset-2 hover:text-default"
          : "text-primary px-1 no-underline"
      }
      href="https://replo.app/privacy"
      target="_blank"
      rel="noreferrer"
    >
      Privacy Policy
    </a>
  </div>
);
